import messages from "@/utils/messages";
import UserService from "../../services/UserService";
export default {
  name: "PasswordRecovery",
  data: () => ({
    buttonText: "შემოწმება",
    username: "",
    showOtpBox: false,
    otp: "",
    password: "",
    rePassword: "",
  }),
  components: {},
  mounted() {
    if (messages[this.$route.query.message]) {
      this.$message(messages[this.$route.query.message]);
    }
  },
  methods: {
    submitHandler() {
      if (!this.showOtpBox) {
        UserService.CheckUser(this.username).then((res) => {
          this.showOtpBox = res.checkStatus;
          if (!res.checkStatus) {
            this.$message("მომხმარებელი ვერ მოიძებნა");
          } else {
            this.buttonText = "გაგრძელება";
          }
        });
      } else {
        if (this.rePassword == this.password) {
          UserService.ResetPassword(
            this.username,
            this.otp,
            this.rePassword
          ).then((res) => {
            if (res.resetStatusCode == 0) {
              this.$message(
                "პაროლი წარმატებით შეიცვალა, გთხოვთ გაიაროთ ავტორიზაცია"
              );
              this.$router.push("/login");
            }
          });
        } else {
          this.$message("პაროლები არ ემთხვევა ერთმანეთს");
        }
      }
    },
  },
};
